/**
 * LoveLab recently-viewed for YOU MAY ALSO LOVE.
 * Records product views, then injects Shopify Liquid cards via Section Rendering API
 * (native | money prices — never format money in JS).
 */
(function () {
  var KEY = 'lovelab_recently_viewed';
  var MAX = 8;
  var GRID_SIZE = 4;
  var MAX_RECENT = 2;
  var SECTION_ID = 'll-recently-viewed-card';

  function handleFromPath(path) {
    if (!path) return '';
    try {
      var pathname = path;
      if (String(path).indexOf('http') === 0) {
        pathname = new URL(path, window.location.origin).pathname;
      }
      var m = String(pathname).match(/\/products\/([^/?#]+)/);
      return m ? decodeURIComponent(m[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function handleOf(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);
    if (item.path) {
      var fromPath = handleFromPath(item.path);
      if (fromPath) return fromPath;
    }
    if (item.id && isNaN(Number(item.id))) return String(item.id);
    return '';
  }

  function sanitizeItem(item) {
    if (!item) return null;
    var handle = handleOf(item);
    var path = item.path || (handle ? '/products/' + handle : '');
    if (!handle || !path) return null;
    return {
      id: handle,
      handle: handle,
      productId: item.productId || item.product_id || null,
      name: item.name || '',
      path: path,
      image: item.image || '',
    };
  }

  function getRecentlyViewed() {
    try {
      var raw = localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(list)) return [];
      return list.map(sanitizeItem).filter(Boolean);
    } catch (e) {
      return [];
    }
  }

  function recordRecentlyViewed(item) {
    var clean = sanitizeItem(item);
    if (!clean) return;
    try {
      var next = [clean].concat(
        getRecentlyViewed().filter(function (i) {
          return handleOf(i) !== clean.handle;
        })
      ).slice(0, MAX);
      localStorage.setItem(KEY, JSON.stringify(next));
    } catch (e) {
      /* ignore private mode / quota */
    }
  }

  function parseJson(raw) {
    if (!raw) return null;
    try {
      return sanitizeItem(JSON.parse(raw));
    } catch (e) {
      return null;
    }
  }

  function parseCurrentProduct(root) {
    var jsonEl =
      (root && root.querySelector('.ll-current-product-json')) ||
      document.getElementById('ll-current-product-json');
    if (jsonEl && jsonEl.textContent) {
      var fromScript = parseJson(jsonEl.textContent);
      if (fromScript) return fromScript;
    }
    if (root) return parseJson(root.getAttribute('data-current-product'));
    return parseJson(
      document.querySelector('[data-current-product]') &&
        document.querySelector('[data-current-product]').getAttribute('data-current-product')
    );
  }

  function imageSrc(url) {
    if (!url) return '';
    return url.indexOf('//') === 0 ? 'https:' + url : url;
  }

  function isLifestyleSrc(src) {
    var file = String(src || '')
      .split('?')[0]
      .split('#')[0]
      .split('/')
      .pop()
      .toLowerCase();
    if (!file) return false;
    return (
      file.indexOf('lifestyle') !== -1 ||
      file.indexOf('banner') !== -1 ||
      file.indexOf('shapyshine') !== -1 ||
      file === 'shine_pear.webp' ||
      file === 'shine_heart.webp'
    );
  }

  function usableSrc(img) {
    if (!img) return '';
    var src = img.currentSrc || img.getAttribute('src') || '';
    if (!src || src.indexOf('data:') === 0 || isLifestyleSrc(src)) return '';
    return imageSrc(src);
  }

  function captureGalleryImage() {
    var packshot = usableSrc(document.querySelector('#ll-cuty-main-image'));
    if (packshot) return packshot;

    var list = document.querySelector('.ll-cuty-media-list');
    if (list) {
      var items = list.querySelectorAll('.ll-cuty-media-item');
      var i;
      var src;
      for (i = 0; i < items.length; i++) {
        src = usableSrc(items[i].querySelector('img'));
        if (src) return src;
      }
    }

    var selectors = [
      '.ll-cuty-media-item .ll-image-zoom__img',
      '.product__media img',
      '.product__media-wrapper img',
    ];
    for (var s = 0; s < selectors.length; s++) {
      var fallback = usableSrc(document.querySelector(selectors[s]));
      if (fallback) return fallback;
    }
    return '';
  }

  function enrichCurrentProduct(item) {
    if (!item) return null;
    var gallery = captureGalleryImage();
    if (gallery) item.image = gallery;
    return item;
  }

  function applyRecentlyViewedBadge(li, label) {
    var badgeHost =
      li.querySelector('.card__badge') ||
      li.querySelector('.ll-recently-viewed-card__badge');

    if (badgeHost) {
      badgeHost.innerHTML = '';
      var span = document.createElement('span');
      span.className = 'badge ll-badge--recently-viewed';
      span.textContent = label || 'Recently Viewed';
      badgeHost.appendChild(span);
      return;
    }

    var media =
      li.querySelector('.card__inner') ||
      li.querySelector('.card__media') ||
      li.querySelector('.ll-recently-viewed-card__media');
    if (!media) return;
    if (getComputedStyle(media).position === 'static') {
      media.style.position = 'relative';
    }
    var wrap = document.createElement('div');
    wrap.className = 'll-recently-viewed-card__badge';
    wrap.style.cssText = 'position:absolute;top:0;left:0;z-index:2;';
    var span = document.createElement('span');
    span.className = 'badge ll-badge--recently-viewed';
    span.textContent = label || 'Recently Viewed';
    wrap.appendChild(span);
    media.insertBefore(wrap, media.firstChild);
  }

  function directGridItems(grid) {
    var result = [];
    for (var i = 0; i < grid.children.length; i++) {
      var child = grid.children[i];
      if (child.nodeType === 1 && child.classList.contains('grid__item')) {
        result.push(child);
      }
    }
    return result;
  }

  function sectionCardUrl(item) {
    /* Always fetch in the current language (saved paths may be /fr/… or unprefixed). */
    var root = (window.llProductRoot && window.llProductRoot()) || '/';
    var path = item.handle ? root + 'products/' + item.handle : (item.path || '');
    if (!path) return '';
    try {
      var url = new URL(path, window.location.origin);
      if (url.pathname.indexOf('/products/') === -1 && item.handle) {
        url.pathname = '/products/' + item.handle;
      }
      url.searchParams.set('view', 'recent-card');
      url.searchParams.set('section_id', SECTION_ID);
      return url.pathname + url.search;
    } catch (e) {
      var productPath = item.handle ? root + 'products/' + item.handle : path;
      var sep = productPath.indexOf('?') >= 0 ? '&' : '?';
      return productPath + sep + 'view=recent-card&section_id=' + encodeURIComponent(SECTION_ID);
    }
  }

  function fetchLiquidCard(item) {
    var url = sectionCardUrl(item);
    if (!url) return Promise.resolve(null);
    return fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('section ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var li =
          doc.querySelector('.grid__item') ||
          doc.querySelector('li[data-product-handle]');
        if (!li) return null;
        return document.importNode(li, true);
      })
      .catch(function () {
        return null;
      });
  }

  function layoutGrid(grid, visible, pool) {
    while (grid.firstChild) {
      grid.removeChild(grid.firstChild);
    }
    visible.forEach(function (el) {
      el.hidden = false;
      el.style.display = '';
      grid.appendChild(el);
    });
    pool.forEach(function (el) {
      if (visible.indexOf(el) !== -1) return;
      el.hidden = true;
      el.style.display = 'none';
      grid.appendChild(el);
    });
  }

  /** Fisher–Yates shuffle — new order each page load for Best Sellers rotation */
  function shuffleArray(items) {
    var arr = items.slice();
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function remixGrid(root) {
    if (root.getAttribute('data-ll-rv-ready') === '1') return;
    root.setAttribute('data-ll-rv-ready', '1');

    var grid = root.querySelector('.ll-best-sellers-grid');
    if (!grid) return;

    var gridSize = parseInt(root.getAttribute('data-grid-size'), 10) || GRID_SIZE;
    var current = enrichCurrentProduct(parseCurrentProduct(root));
    var excludeHandle = current ? current.handle : null;
    var label = root.getAttribute('data-recently-viewed-label') || 'Recently Viewed';

    var pool = directGridItems(grid);
    var byHandle = {};
    pool.forEach(function (el) {
      var handle = el.getAttribute('data-product-handle') || '';
      if (handle) byHandle[handle] = el;
    });

    var candidates = getRecentlyViewed()
      .filter(function (rv) {
        return rv.handle && rv.handle !== excludeHandle;
      })
      .slice(0, MAX_RECENT);

    var fetches = candidates.map(function (rv) {
      if (byHandle[rv.handle]) {
        return Promise.resolve({ item: rv, el: byHandle[rv.handle] });
      }
      return fetchLiquidCard(rv).then(function (el) {
        return { item: rv, el: el };
      });
    });

    Promise.all(fetches).then(function (results) {
      var shownRecent = [];
      var recentHandles = {};

      results.forEach(function (row) {
        if (!row || !row.el || !row.item) return;
        var handle = row.item.handle;
        if (!handle || recentHandles[handle]) return;
        recentHandles[handle] = true;
        row.el.classList.add('ll-recently-viewed-item');
        row.el.setAttribute('data-product-handle', handle);
        applyRecentlyViewedBadge(row.el, label);
        shownRecent.push(row.el);
      });

      var bestKeep = Math.max(gridSize - shownRecent.length, 0);
      var bestPool = shuffleArray(
        pool.filter(function (el) {
          var handle = el.getAttribute('data-product-handle') || '';
          return handle && !recentHandles[handle] && handle !== excludeHandle;
        })
      );
      var shownBest = bestPool.slice(0, bestKeep);

      layoutGrid(grid, shownBest.concat(shownRecent), pool.concat(shownRecent));

      if (current) {
        recordRecentlyViewed(current);
        setTimeout(function () {
          recordRecentlyViewed(enrichCurrentProduct(current));
        }, 600);
      }
    });
  }

  function recordFromPage() {
    var current = enrichCurrentProduct(parseCurrentProduct(null));
    if (current) recordRecentlyViewed(current);
  }

  function init() {
    recordFromPage();
    document.querySelectorAll('[data-ll-recently-viewed]').forEach(remixGrid);
  }

  if (window.LLRecentlyViewed) {
    window.LLRecentlyViewed.init();
    return;
  }

  window.LLRecentlyViewed = {
    get: getRecentlyViewed,
    record: recordRecentlyViewed,
    init: init,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
